import { render } from "./SupplierInvoicesView.vue?vue&type=template&id=706b842f"
import script from "./SupplierInvoicesView.vue?vue&type=script&lang=js"
export * from "./SupplierInvoicesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__